import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import EntityId from '../../foundation/domain/EntityId';
import Page from './Page';
import AceEditor from 'react-ace';
import { Form, Input, Button, Dropdown, Table, Grid, Breadcrumb, Header, Icon } from 'semantic-ui-react';

import 'brace/mode/xml';
import 'brace/theme/monokai';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';
import LessonApi from '../modules/lessons/api/LessonApi';
import ExerciseComponent from './components/exercises/ExerciseComponent';
import ExerciseTemplateApi from '../modules/lessons/api/ExerciseTemplateApi';
import Registry from '../global/Registry';
import BBMLParser from './components/exercises/BBMLParser';
import ExerciseTemplate from '../modules/lessons/domain/aggregates/exerciseTemplate/ExerciseTemplate';
import CourseApi from '../modules/lessons/api/CourseApi';
import {Link} from 'react-router-dom';

interface Props {
	lessonId: string;
	id?: string;
	templateId?: string;
}

interface State {
	exercise?: Exercise;
	lessons: Lesson[];
	lesson?: Lesson;
	preview: boolean;
	exercises: Exercise[];
}

export default class EditExercisePage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], preview: false, exercises: [] };
	}

	async componentWillMount () {
		await this.initialize(this.props);
	}

	async componentWillReceiveProps (props: RouteComponentProps<Props>) {
		await this.initialize(props);
	}

	async initialize (props: Readonly<RouteComponentProps<Props>>) {
		await CourseApi.getInstance().getAll();
		const lessons = await LessonApi.getInstance().getAll();
		await ExerciseTemplateApi.getInstance().getAll();
		const exerciseIdValue = this.props.match.params.id;
		const templateIdValue = this.props.match.params.templateId;
		const exercise = exerciseIdValue !== undefined ? await ExerciseApi.getInstance().getById(new EntityId<Exercise>(Number(exerciseIdValue))) : templateIdValue !== undefined ? this.createExercise(new EntityId<ExerciseTemplate>(Number(templateIdValue))) : undefined;
		const lesson = Registry.getInstance().lessonRepository.getById(exercise ? exercise.getLessonId() : new EntityId<Lesson>(Number(props.match.params.lessonId)));
		const exercises = await ExerciseApi.getInstance().getAllByCourseId(lesson.getCourseId());

		this.setState({exercise, lessons, lesson, exercises});
	}

	protected saveExercise = async (newExercise = false, sameExercise = false) => {
		let exercise = this.state.exercise as Exercise;

		await ExerciseApi.getInstance().save(exercise);

		const lesson = Registry.getInstance().lessonRepository.getById(exercise.getLessonId());

		Page.navigate( lesson.getSlug() + (!newExercise ? '/exercises' : sameExercise ? '/exercise/new/' + exercise.getTemplateId().getValue() : '/exercise/new'));
	}

	protected deleteExercise = async () => {
		let exercise = this.state.exercise as Exercise;

		Registry.getInstance().askConfirmation('Are you sure you want to delete this exercise?', async () => {
			await ExerciseApi.getInstance().delete(exercise.getId());

			const lesson = Registry.getInstance().lessonRepository.getById(exercise.getLessonId());

			Page.navigate(lesson.getSlug() + '/exercises');
		});
	}

	protected isLoading () {
		return this.props.match.params.id !== undefined && this.state.exercise === undefined || this.state.lesson === undefined;
	}

	protected renderTitle () {
		return '';
	}

	protected renderDescription () {
		return '';
	}

	protected renderContent () {
		const exercise = this.state.exercise;

		const me = Registry.getInstance().me;

		const templates = me.isErik() ? Registry.getInstance().exerciseTemplateRepository.getAll() : Registry.getInstance().exerciseTemplateRepository.getPublicList();

		const lesson = this.state.lesson as Lesson;
		const course = Registry.getInstance().courseRepository.getById(lesson.getCourseId());

		const sections = [{ key: 'Home', content: <Link to='/'>Home</Link> }, { key: 'Course', content: <Link to={course.getSlug()}>{course.getName()}</Link> }, { key: 'Lesson', content: <Link to={lesson.getSlug()}>{lesson.getTitle()}</Link>}, { key: 'Exercise', content: 'Exercise', active: true}];

		if (exercise === undefined) {
			return (
				<div className='lesson'>
					<Breadcrumb icon='right angle' sections={sections} />
					<Header inverted as={'h1'} dividing>New Exercise</Header>
					<Table inverted selectable unstackable>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell colSpan={2}>Choose an exercise type</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{templates.map((template, index) => <Table.Row key={index} onClick={() => this.setState({ exercise: this.createExercise(template.getId())})}><Table.Cell>{template.getName()}<br/><span style={{color: 'grey', fontSize: '0.8em'}}>{template.getDescription()}</span></Table.Cell></Table.Row>)}
						</Table.Body>
					</Table>
				</div>
			);
		}

		console.log(exercise.getQuestion());

		const exerciseTemplate = exercise.getTemplateId().isNull() ? null : Registry.getInstance().exerciseTemplateRepository.getById(exercise.getTemplateId());
		const templateName = exerciseTemplate === null ? '' : exerciseTemplate.getName();

		return (
			<div className='lesson'>
				<Breadcrumb icon='right angle' sections={sections} />
				<Header inverted as={'h1'} dividing>{templateName}</Header>
				<Form inverted>
					{!this.state.preview ? (
						<div>
							{me.isErik() ? (
								<Form.Field>
									<label>Lesson</label>
									<Dropdown fluid search selection options={this.state.lessons.map((lesson) => { return {key: lesson.getId().getValue(), value: lesson.getId().getValue() as number, text: lesson.getTitle()}; })} onChange={(a, b) => this.setState({exercise: exercise.updateLessonId(new EntityId<Lesson>(Number(b.value)))})} value={lesson.getId().getValue() as number} />
								</Form.Field>
							) : null}
							{this.renderContentFields(exercise)}
						</div>
					) : (
						<ExerciseComponent key={'exercise_' + exercise.getId().getValue()} editingMode={true} exercise={exercise} content={exercise.getContent()} />
					)}
					<Form.Field style={{marginTop: '32px'}}>
						<Grid columns='equal'>
							<Grid.Row>
							</Grid.Row>
							<Grid.Row>
								<Grid.Column>
									<Button type={'button'} color={'grey'} fluid onClick={() => this.setState({preview: !this.state.preview})}><Icon name={!this.state.preview ? 'eye' : 'pencil'} /> {this.state.preview ? 'Edit' : 'Preview'}</Button>
								</Grid.Column>
								<Grid.Column>
									<Button color='blue' fluid onClick={() => this.saveExercise(false, false)}><Icon name={'save'} /> Save</Button>
								</Grid.Column>
								<Grid.Column>
									{exercise.hasId() ? <Button type={'button'} color='red' fluid onClick={this.deleteExercise}><Icon name={'trash'} /> Delete</Button> : <Button color='blue' fluid onClick={() => this.saveExercise(true, true)}><Icon name={'plus'} /> Save + new similar</Button>}
								</Grid.Column>
								{/*<Grid.Column>*/}
									{/*<Button color='blue' fluid onClick={() => this.saveExercise(true, true)}>Save + new same exercise</Button>*/}
								{/*</Grid.Column>*/}
							</Grid.Row>
						</Grid>
					</Form.Field>
				</Form>
			</div>
		);
	}

	private createExercise (templateId: EntityId<ExerciseTemplate>) {
		return Exercise.create(new EntityId<Lesson>(Number(this.props.match.params.lessonId)), templateId);
	}

	private renderContentFields (exercise: Exercise) {
		if (exercise.getTemplateId().isNull()) {
			return null;
		}

		const template = Registry.getInstance().exerciseTemplateRepository.getById(exercise.getTemplateId());

		const matches = template.getContent().match(/{{([^}]+)}}/g);

		if (matches === null) {
			return null;
		}

		return matches.map((value: string, index: number) => this.renderContentField(exercise, index, value.substr(2, value.length - 4).split(':')[0], value.substr(2, value.length - 4).split(':')[1]));
	}

	private renderContentField (exercise: Exercise, index: number, name: string, type: string) {
		return (
			<Form.Field key={index}>
				<label>{name}</label>
				{this.renderControl(exercise, index, type)}
			</Form.Field>
		);
	}

	private renderControl (exercise: Exercise, index: number, type: string) {
		switch (type) {
			case 'boolean':
				return <Dropdown fluid selection options={[{key: 'true', value: 'true', text: 'true'}, {key: 'false', value: 'false', text: 'false'}]} onChange={(a, b) => this.setState({exercise: exercise.updateContentAtIndex(index, b.value as string)})} value={exercise.getContents()[index]} />;
			case 'choiceIndex':
				return <Dropdown fluid selection options={!exercise.hasContentAtIndex(index) ? [] : exercise.getContents()[index + 1].split('\n').map((choice, choiceIndex) => {return {key: choiceIndex, value: String(choiceIndex), text: BBMLParser.executeWithoutException(choice)}; })} onChange={(a, b) => this.setState({exercise: exercise.updateContentAtIndex(index, b.value as string)})} value={exercise.getContents()[index]} />;
			case 'choices':
			case 'values':
			case 'xml':
				return <AceEditor mode='xml' theme='monokai' width='100%' height='160px' showPrintMargin={false} value={exercise.getContents()[index]} onChange={(content) => this.setState({exercise: exercise.updateContentAtIndex(index, content)})}  />;
			case 'text':
				return <Input transparent style={{ color: 'white' }} value={exercise.getContents()[index]} onChange={(event: any) => this.setState({exercise: exercise.updateContentAtIndex(index, event.target.value)})} />;
			case 'contains':
				return <Dropdown placeholder='Select the words that are contained in the answer of this exercise' fluid multiple search selection options={_.sortBy(this.state.exercises, exercise => (exercise.getAnswer() as string).toLocaleLowerCase()).map((exercise) => { return {key: exercise.getId().getValue(), value: exercise.getId().getValue() as number, text: exercise.getAnswer() + ' - ' + exercise.getQuestion()}; })} onChange={(a, b) => this.setState({exercise: exercise.updateContentAtIndex(index, (b.value as Number[]).join(','))})} value={exercise.getContents()[index].split(',').filter(value => value !== '').map(value => Number(value))} />;
			default:
				throw new Error('Unknown control type: ' + type);
		}
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/EditExercisePage.tsx